/* src/app/features/prestacao-informacoes/acompanhamento-depr/acompanhamento-depr-cadastro/aba-historico/aba-historico.component.scss */
/*# sourceMappingURL=aba-historico.component.css.map */
